export default {
  token: "",
  user: {
    userName: "",
    nickName: "",
    imageUrl: "",
    id: "",
    userId: "",
    userMobile: "",
    userType: '' // 用户身份：0个人用户，1企业用户
  },

  key_: null,
  userCartCount: 0 //菜单栏购物车数量
};